<template>
  <router-view />
</template>

<script>
export default {
  name: 'contacerta-validations-layout',
  emits: ['loading'],
  created() {
    this.$emit('loading', false);
  }
};
</script>
